import { useState } from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";

export default function Layout({ children }) {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className="flex min-h-screen bg-gray-100">

            <Sidebar
                isOpen={sidebarOpen}
                onClose={() => setSidebarOpen(false)}
            />

            <div className="flex-1 min-w-0">

                <Navbar
                    onMenuClick={() => setSidebarOpen(true)}
                />

                <main className="p-3 sm:p-4">
                    {children}
                </main>

            </div>

        </div>
    );
}